export default __webpack_public_path__ + "static/media/slider-5.049916e6.jpg";